import { Link } from "react-router-dom";
import { Phone, Mail, Globe, MapPin } from "lucide-react";

export function Footer() {
  return (
    <footer data-testid="main-footer" className="border-t border-white/10 bg-[#0a0a0a] mt-24">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2">
          <img src="/logo.png" alt="AS AUTO Garage" className="h-24 w-auto object-contain -ml-2" />
          <p className="mt-4 text-neutral-400 max-w-md leading-relaxed">
            Votre partenaire automobile, de l'achat à la réparation. Achat • Vente • Importation •
            Recherche personnalisée • Réparation toutes marques.
          </p>
          <p className="mt-6 font-display text-lg text-white">Votre automobile. Notre expertise.</p>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-neutral-500 mb-4">Navigation</h4>
          <ul className="space-y-2 text-sm text-neutral-300">
            <li><Link to="/vehicules" className="hover:text-[#C5A059]">Nos véhicules</Link></li>
            <li><Link to="/vendre" className="hover:text-[#C5A059]">Vendre mon véhicule</Link></li>
            <li><Link to="/recherche" className="hover:text-[#C5A059]">Recherche personnalisée</Link></li>
            <li><Link to="/importation" className="hover:text-[#C5A059]">Importation</Link></li>
            <li><Link to="/atelier" className="hover:text-[#C5A059]">Atelier / Réparation</Link></li>
            <li><Link to="/application" className="hover:text-[#C5A059]">Application</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-neutral-500 mb-4">Contact</h4>
          <ul className="space-y-3 text-sm text-neutral-300">
            <li><a href="tel:0767876026" className="flex items-center gap-2 hover:text-[#C5A059]"><Phone className="h-4 w-4 text-[#C5A059]" /> 07 67 87 60 26</a></li>
            <li><a href="mailto:as.56.auto@gmail.com" className="flex items-center gap-2 hover:text-[#C5A059]"><Mail className="h-4 w-4 text-[#C5A059]" /> as.56.auto@gmail.com</a></li>
            <li><a href="https://www.google.com/maps/search/?api=1&query=3+rue+de+Kerandr%C3%A9+56700+Hennebont" target="_blank" rel="noreferrer" className="flex items-start gap-2 hover:text-[#C5A059]"><MapPin className="h-4 w-4 text-[#C5A059] mt-0.5 shrink-0" /> 3 rue de Kerandré, 56700 Hennebont</a></li>
            <li><span className="flex items-center gap-2"><Globe className="h-4 w-4 text-[#C5A059]" /> as-auto.fr</span></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-neutral-500">
          <p>© {new Date().getFullYear()} AS AUTO — Une solution pour chaque projet automobile.</p>
          <p className="tracking-[0.15em] uppercase">Achat • Vente • Importation • Recherche • Réparation</p>
        </div>
      </div>
    </footer>
  );
}
